import { get } from '../../shared/utils/fetch.util'

export const getPromoCodeAPI = code =>
  get(`/v2/promo-codes/codes/${code}`).then(resp => resp.data)
